module.exports = __webpack_public_path__ + "../../static/img/tree.478c473d.gif";